(function (angular) {
  "use strict";

  angular.module("app").controller("forumSearchController", searchController);

  searchController.$inject = [
    "$location",
    "$rootScope",
    "ForumSearchApi",
    "UsersApi",
    "q",
  ];

  function searchController(
    $location,
    $rootScope,
    ForumSearchApi,
    UsersApi,
    q,
  ) {
    var BY_USER = /by:([a-zA-Z0-9_-]+)/i;
    var vm = this;

    vm.findUsers = findUsers;
    vm.searchForum = searchForum;

    vm.isFindingUsers = false;
    vm.isSearching = false;
    vm.query = $location.search()["q"] || q;
    vm.results = [];
    vm.resultsString = "";
    vm.users = [];
    vm.user = null;

    init(vm.query);

    /**
     * Initialise the controller.
     *
     * @param  {String} query
     * @return {void}
     */
    function init(query) {
      if (BY_USER.test(query)) {
        // Load the user by slug.
        vm.findUsers({ slug: query.match(BY_USER)[1] }).then(function (users) {
          vm.user = users[0];
        });
      }

      if (query) {
        vm.searchForum(query);
      }
    }

    /**
     * Get the users by the
     *
     * @param  {Object} params
     * @return {void}
     */
    function findUsers(params) {
      vm.users = [];
      vm.isFindingUsers = true;

      return UsersApi.get(params).$promise.then(
        function handle(resp) {
          vm.users = resp.data;
          vm.isFindingUsers = false;

          return resp.data;
        },
        function error() {
          vm.isFindingUsers = false;
        },
      );
    }

    /**
     * Get the forum with the query which has been specified.
     *
     * @param  {String} query
     * @return {void}
     */
    function searchForum(query) {
      vm.isSearching = true;

      return ForumSearchApi.get({ query: query || vm.query }).$promise.then(
        function handle(resp) {
          vm.results = resp.results;
          vm.resultsString =
            "Found " +
            resp.results.length +
            " result" +
            (resp.results.length !== 1 ? "s" : "");
          vm.isSearching = false;

          return resp.results;
        },
        function error() {
          vm.isSearching = false;
        },
      );
    }
  }
})(angular);
